export const INVOICE_STATUS = {
  draft: { label: 'Draft', badge: 'inv-badge inv-badge--draft' },
  sent: { label: 'Terkirim', badge: 'inv-badge inv-badge--sent' },
  paid: { label: 'Lunas', badge: 'inv-badge inv-badge--paid' },
  cancelled: { label: 'Batal', badge: 'inv-badge inv-badge--cancelled' }
};

export function formatRp(n) {
  return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
}

export function statusMeta(status) {
  return INVOICE_STATUS[status] || { label: status || '—', badge: 'inv-badge inv-badge--muted' };
}
